import { validateContentSearch } from "../features/content/search";
import { createFileRoute } from "@tanstack/react-router";
import { ProtectedPage } from "../app/route-boundaries";
import { AdminAppCategoriesRoute } from "../pages/AdminAppContentRoutes";
export const Route = createFileRoute("/app/content/categories")({ validateSearch: validateContentSearch, component: () => <ProtectedPage><AdminAppCategoriesRoute /></ProtectedPage> });
